import { Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import InspectorRoutes from "./routes/InspectorRoutes.jsx";
import AdminRoutes from "./routes/AdminRoutes.jsx";
import SupervisorRoutes from "./routes/SupervisorRoutes.jsx";
import LoginPage from "./pages/LoginPage";
import { getToken, getUser } from "./utils/auth";
import { useEffect } from "react";
import { initClickTracking, setCurrentInspectorId } from "./utils/clickTracking";
const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const token = getToken();
  const user = getUser();

  if (!token || !user) return <Navigate to="/login" />;

  if (allowedRoles.length && !allowedRoles.includes(user.role)) {
    return <Navigate to={`/${user.role}`} />;
  }

  return children;
};

function App() {
  useEffect(() => {
    initClickTracking();
    // Set current inspector ID from localStorage if user is logged in
    const user = getUser();
    if (user && user.id) {
      setCurrentInspectorId(user.id);
      console.log('Click tracking initialized for inspector:', user.id);
    }
  }, []);
  
  return (
    <>
      <Toaster position="top-right" />
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protected routes */}
        <Route
          path="/inspector/*"
          element={
            <ProtectedRoute allowedRoles={["inspector"]}>
              <InspectorRoutes />
            </ProtectedRoute>
          }
        />
        <Route
          path="/superadmin/*"
          element={
            <ProtectedRoute allowedRoles={["superadmin"]}>
              <AdminRoutes />
            </ProtectedRoute>
          }
        />
        <Route
          path="/supervisor/*"
          element={
            <ProtectedRoute allowedRoles={["supervisor"]}>
              <SupervisorRoutes />
            </ProtectedRoute>
          }
        />

        {/* Default role-based redirect */}
        <Route
          path="/"
          element={
            getToken() && getUser() ? (
              <Navigate to={`/${getUser()?.role}`} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
      </Routes>
    </>
  );
}

export default App;
